import React, { useState, useRef, useEffect } from "react";
import Lang from "./Lang";
import "./PremiumStaffSelect.css"; // Reuse the same premium styling

export default function PremiumSelect({ choices, value, setValue, label, none = false }) {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  const isObjectList = choices.length > 0 && typeof choices[0] === "object";
  
  const selectedItem = isObjectList 
    ? choices.find(c => c._id === value) 
    : choices.find(c => c === value);

  useEffect(() => {
    function handleClickOutside(event) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <div className="premium-select-container" ref={dropdownRef}>
      <label className="premium-select-label">
        {typeof label === 'string' ? <Lang w={label} /> : label}
      </label>
      <div
        className={`premium-select-trigger ${isOpen ? "active" : ""}`}
        onClick={() => setIsOpen(!isOpen)}
      >
        <span className={selectedItem ? "selected-text" : "placeholder"}>
          {selectedItem ? (isObjectList ? selectedItem.name : selectedItem) : "Select..."}
        </span>
        <div className={`chevron ${isOpen ? "up" : "down"}`}>▾</div>
      </div>

      {isOpen && (
        <div className="premium-dropdown">
          <div className="dropdown-list">
            {none && (
              <div
                className="dropdown-item"
                onClick={() => {
                  setValue("");
                  setIsOpen(false);
                }}
              >
                None
              </div>
            )}
            {choices.map((choice, idx) => {
              const itemValue = isObjectList ? choice._id : choice;
              const itemName = isObjectList ? choice.name : choice;
              return (
                <div
                  key={idx}
                  className={`dropdown-item ${itemValue === value ? "selected" : ""}`}
                  onClick={() => {
                    setValue(itemValue);
                    setIsOpen(false);
                  }}
                >
                  {itemName}
                </div>
              );
            })}
          </div>
        </div>
      )}
    </div>
  );
}
